export const skills = [
  {
    skillName: "HTML",
  },
  {
    skillName: "CSS",
  },
  {
    skillName: "SCSS",
  },
  {
    skillName: "Bootstrap",
  },
  {
    skillName: "TailwindCSS",
  },
  {
    skillName: "JavaScript",
  },
  {
    skillName: "TypeScript",
  },
  {
    skillName: "React.js",
  },
  {
    skillName: "Redux",
  },
  {
    skillName: "Redux-Thunk",
  },
  {
    skillName: "Axios",
  },
  {
    skillName: "Git",
  },
  {
    skillName: "GitHub",
  },
  {
    skillName: "Docker",
  },
  {
    skillName: "Webpack",
  },
  {
    skillName: "PostCSS",
  },
  {
    skillName: "Unite Testing",
  },
  {
    skillName: "Integration Testing",
  },
  {
    skillName: "JsDocks",
  },
  {
    skillName: "Algorithms",
  },
  {
    skillName: "Data Structures",
  },
  {
    skillName: "Functional Programming",
  },
  {
    skillName: "OOP",
  },
  {
    skillName: "VueJs",
  },
  {
    skillName: "Angular 2+",
  },
  {
    skillName: "C++",
  },
  {
    skillName: "LifeRay",
  },
  {
    skillName: "Yeoman",
  },
  {
    skillName: "NodeJs",
  },
  {
    skillName: "Express.js",
  },
  {
    skillName: "MongoDB",
  },
  {
    skillName: "Mongoose",
  },
  {
    skillName: "SQL",
  },
  {
    skillName: "NoSQL",
  },
  {
    skillName: "DataBase",
  },
];

export const education = [
  {
    title: "Information Technology Institute (ITI)",
    location: "Alexandria",
    degree: "Diploma",
    from: 2019,
    to: 2020,
  },
  {
    title: "Faculty of Fine Arts",
    location: "Alexandria",
    degree: "Bachelor",
    from: 2011,
    to: 2017,
  },
];

export const experience = [
  {
    title: "Senior Front-End Develper",
    company: "Naseej",
    from: 2021,
    to: "Present",
  },
  {
    title: "Senior Front-End Develper",
    company: "Link Development",
    from: 2021,
    to: 2022,
  },
  {
    title: "Front-End Engineer",
    company: "Ibtikar Technologies",
    from: 2019,
    to: 2021,
  },
  {
    title: "Front-End Engineer",
    company: "RM Events",
    from: 2019,
    to: 2020,
  },
  {
    title: "Front-End Engineer",
    company: "Ten Degrees",
    from: 2019,
    to: 2020,
  },
  {
    title: "Online Instructor",
    company: "Udemy, Skillshare and Edunix",
    from: 2017,
    to: "Present",
  },
];
